/**
 * Professional Access — Multi-step Registration Wizard
 * Vanilla JS — no dependencies
 */
(function () {
  'use strict';

  const FORM_SELECTOR = '#ProfessionalAccessForm';
  const STEP_SELECTOR = '.pa-step';
  const PROGRESS_SELECTOR = '.pa-progress';
  const PASSWORD_MIN = 8;
  const REDIRECT_URL = '/products/vacuslim-48-body-counturing-start-up-set';
  const REDIRECT_DELAY_MS = 5000;
  const PENDING_REDIRECT_KEY = 'pa-pending-redirect';

  /* ------- State ------- */
  let allSteps = []; // ordered array of step data-step values
  let currentIndex = 0;
  let includeDistributor = false;

  /* ------- DOM refs (set in init) ------- */
  let form, stepsContainer, progressBar;
  let btnNext, btnBack, btnSubmit, btnBackHome;
  let noteInput, firstNameInput, lastNameInput;
  let pageLang = 'en';

  /* ========================================================
     INIT
     ======================================================== */
  function init() {
    form = document.querySelector(FORM_SELECTOR);
    if (!form) return;

    stepsContainer = form.closest('.professional-access');
    progressBar = stepsContainer.querySelector(PROGRESS_SELECTOR);
    btnNext = form.querySelector('[data-pa-next]');
    btnBack = form.querySelector('[data-pa-back]');
    btnBackHome = form.querySelector('[data-pa-back-home]');
    btnSubmit = form.querySelector('[data-pa-submit]');
    noteInput = form.querySelector('#pa-note');
    firstNameInput = form.querySelector('#pa-first-name');
    lastNameInput = form.querySelector('#pa-last-name');


    // Page language
    var innerEl = stepsContainer.querySelector('.pa-inner') || stepsContainer;
    pageLang = innerEl.getAttribute('data-pa-lang') || document.documentElement.lang || 'en';

    buildStepOrder();
    renderProgress();

    // Check for server-side errors and restore wizard state
    var hasServerError = form.querySelector('.form-status__message--error');
    var hasSuccess = form.querySelector('.form-status__message--success');

    if (hasSuccess) {
      // Clear saved state on success
      sessionStorage.removeItem('pa-wizard-data');
      sessionStorage.removeItem('pa-wizard-step');
      sessionStorage.removeItem('pa-wizard-distributor');
      sessionStorage.removeItem(PENDING_REDIRECT_KEY);
      showSuccessAndRedirect();
      return;
    } else if (hasServerError && sessionStorage.getItem('pa-wizard-data')) {
      // Restore wizard state after server error (e.g. duplicate email)
      restoreWizardState();
    } else {
      showStep(0);
    }

    bindEvents();
  }

  /* ========================================================
     SUCCESS SCREEN + REDIRECT
     Shown when the server renders a success message on this page.
     Also handled from bootRedirectCheck() when Shopify auto-redirects
     the new customer elsewhere (e.g. /account) after registration.
     ======================================================== */
  function showSuccessAndRedirect() {
    var overlay = document.createElement('div');
    overlay.id = 'success-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(255,255,255,0.97);display:flex;flex-direction:column;align-items:center;justify-content:center;z-index:9999;font-family:system-ui,-apple-system,Segoe UI,sans-serif;padding:24px;text-align:center;';
    overlay.innerHTML = '<div style="font-size:80px;color:#3b1f5e;line-height:1;">✓</div>' +
      '<h2 style="color:#3b1f5e;margin-top:16px;font-size:26px;font-weight:600;max-width:560px;">Account created successfully!</h2>' +
      '<p style="color:#3b1f5e;margin-top:16px;font-size:18px;font-weight:600;max-width:560px;">You\'ve received a 20% discount!</p>' +
      '<p style="color:#444;margin-top:8px;max-width:560px;">Your discount code has been sent to your email.</p>' +
      '<p style="color:#888;margin-top:20px;font-size:14px;">Redirecting you to your professional starter set...</p>';
    document.body.appendChild(overlay);

    setTimeout(function () {
      window.location.href = REDIRECT_URL;
    }, REDIRECT_DELAY_MS);
  }

  /* ========================================================
     RESTORE WIZARD STATE (after server-side error)
     ======================================================== */
  function restoreWizardState() {
    try {
      var savedData = JSON.parse(sessionStorage.getItem('pa-wizard-data'));
      var savedStep = parseInt(sessionStorage.getItem('pa-wizard-step'), 10) || 0;
      var savedDistributor = sessionStorage.getItem('pa-wizard-distributor') === 'true';

      // Restore distributor flag (affects step order)
      includeDistributor = savedDistributor;
      buildStepOrder();
      renderProgress();

      // Restore radio selections
      if (savedData) {
        Object.keys(savedData).forEach(function (key) {
          var entry = savedData[key];
          if (entry && entry.value) {
            // Radio button
            var radio = form.querySelector('input[type="radio"][name="' + key + '"][value="' + entry.value + '"]');
            if (radio) {
              radio.checked = true;
              var option = radio.closest('.pa-option');
              if (option) {
                var group = option.closest('.pa-options');
                if (group) {
                  group.querySelectorAll('.pa-option').forEach(function (o) {
                    o.classList.remove('pa-option--selected');
                  });
                }
                option.classList.add('pa-option--selected');
              }
            }
          } else if (typeof entry === 'string') {
            // Text input / select / textarea
            var input = form.querySelector('[data-pa-field="' + key + '"]');
            if (input) input.value = entry;
          }
        });
      }

      // Move error message into the contact step
      var errorEl = form.querySelector('.form-status');
      var contactStepEl = form.querySelector('[data-step="contact"]');
      if (errorEl && contactStepEl) {
        contactStepEl.insertBefore(errorEl, contactStepEl.firstChild);
      }

      // Jump to the last step (contact) where the error occurred
      showStep(savedStep);

      // Clear saved state
      sessionStorage.removeItem('pa-wizard-data');
      sessionStorage.removeItem('pa-wizard-step');
      sessionStorage.removeItem('pa-wizard-distributor');
    } catch (e) {
      console.warn('[PA] Failed to restore wizard state:', e);
      showStep(0);
    }
  }

  /* ========================================================
     STEP ORDER — dynamic based on contact type
     ======================================================== */
  function buildStepOrder() {
    // Base steps (always present)
    const base = ['type', 'business', 'size', 'interest', 'contact'];

    // Check if distributor should be inserted
    if (includeDistributor) {
      base.splice(1, 0, 'distributor'); // after 'type'
    }

    allSteps = base;
  }

  /* ========================================================
     SHOW / HIDE STEPS
     ======================================================== */
  function showStep(index) {
    currentIndex = index;
    const stepName = allSteps[index];

    // Hide all steps
    form.querySelectorAll(STEP_SELECTOR).forEach(function (el) {
      el.classList.remove('pa-step--active');
    });

    // Show target step
    var target = form.querySelector('[data-step="' + stepName + '"]');
    if (target) {
      target.classList.add('pa-step--active');
      // Focus first interactive element
      var firstInput = target.querySelector('input, select, textarea, button');
      if (firstInput && firstInput.type !== 'hidden') {
        setTimeout(function () { firstInput.focus(); }, 100);
      }
    }

    // Update navigation buttons
    updateNav();
    renderProgress();

    // Scroll to top of form
    stepsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function updateNav() {
    var isFirst = currentIndex === 0;
    var isLast = currentIndex === allSteps.length - 1;

    if (btnBack) {
      btnBack.style.display = isFirst ? 'none' : '';
      btnBack.classList.remove('pa-nav__back--hidden');
    }
    if (btnBackHome) {
      btnBackHome.style.display = isFirst ? '' : 'none';
    }
    if (btnNext) {
      btnNext.style.display = isLast ? 'none' : '';
    }
    if (btnSubmit) {
      btnSubmit.style.display = isLast ? '' : 'none';
    }
  }

  /* ========================================================
     PROGRESS BAR
     ======================================================== */
  function renderProgress() {
    if (!progressBar) return;

    var html = '';
    for (var i = 0; i < allSteps.length; i++) {
      var cls = 'pa-progress__step';
      if (i < currentIndex) cls += ' pa-progress__step--completed';
      else if (i === currentIndex) cls += ' pa-progress__step--active';

      html += '<span class="' + cls + '">' + (i + 1) + '</span>';

      if (i < allSteps.length - 1) {
        var lineCls = 'pa-progress__line';
        if (i < currentIndex) lineCls += ' pa-progress__line--completed';
        html += '<span class="' + lineCls + '"></span>';
      }
    }
    progressBar.innerHTML = html;

    // Update aria
    progressBar.setAttribute('aria-label',
      progressBar.getAttribute('data-label-template')
        .replace('{{ current }}', currentIndex + 1)
        .replace('{{ total }}', allSteps.length)
    );
  }

  /* ========================================================
     EVENTS
     ======================================================== */
  function bindEvents() {
    // Next button
    if (btnNext) {
      btnNext.addEventListener('click', function (e) {
        e.preventDefault();
        if (validateCurrentStep()) {
          showStep(currentIndex + 1);
        }
      });
    }

    // Back button
    if (btnBack) {
      btnBack.addEventListener('click', function (e) {
        e.preventDefault();
        if (currentIndex > 0) {
          showStep(currentIndex - 1);
        }
      });
    }

    // Submit button
    if (btnSubmit) {
      btnSubmit.addEventListener('click', function (e) {
        e.preventDefault();
        if (validateCurrentStep()) {
          assembleAndSubmit();
        }
      });
    }

    // Option card click handling (event delegation)
    form.addEventListener('click', function (e) {
      var option = e.target.closest('.pa-option');
      if (!option) return;

      var radio = option.querySelector('input[type="radio"]');
      if (radio) {
        radio.checked = true;
        // Mark siblings
        var group = option.closest('.pa-options');
        if (group) {
          group.querySelectorAll('.pa-option').forEach(function (o) {
            o.classList.remove('pa-option--selected');
          });
        }
        option.classList.add('pa-option--selected');

        // Clear error
        var errEl = option.closest('.pa-question').querySelector('.pa-error');
        if (errEl) errEl.classList.remove('pa-error--visible');

        // Special: contact type changes step flow
        if (radio.name === 'pa_contact_type') {
          handleContactTypeChange(radio.value);
        }
      }
    });

    // Input field error clearing
    function clearFieldError(target) {
      if (!target.classList.contains('input')) return;
      target.classList.remove('pa-input--error');
      var field = target.closest('.pa-field');
      if (field) {
        var err = field.querySelector('.pa-error');
        if (err) err.classList.remove('pa-error--visible');
      }
    }
    form.addEventListener('input', function (e) { clearFieldError(e.target); });
    form.addEventListener('change', function (e) {
      if (e.target.tagName === 'SELECT') clearFieldError(e.target);
    });

    // Keyboard: Enter on option = next
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var option = e.target.closest('.pa-option');
        if (option) {
          e.preventDefault();
          option.click();
          // Brief delay then advance
          setTimeout(function () {
            if (btnNext && btnNext.style.display !== 'none') {
              btnNext.click();
            }
          }, 200);
        }
      }
    });
  }

  /* ========================================================
     CONTACT TYPE CHANGE → toggle distributor step
     ======================================================== */
  function handleContactTypeChange(value) {
    var wasDistributor = includeDistributor;
    includeDistributor = (value === 'distribution' || value === 'both');

    if (wasDistributor !== includeDistributor) {
      buildStepOrder();
      renderProgress();
    }
  }

  /* ========================================================
     VALIDATION
     ======================================================== */
  function validateCurrentStep() {
    var stepName = allSteps[currentIndex];
    var stepEl = form.querySelector('[data-step="' + stepName + '"]');
    if (!stepEl) return true;

    var valid = true;

    // Validate radio groups
    var radioQuestions = stepEl.querySelectorAll('.pa-question[data-required="radio"]');
    radioQuestions.forEach(function (q) {
      var groupName = q.getAttribute('data-group');
      var checked = q.querySelector('input[type="radio"]:checked');
      var errEl = q.querySelector('.pa-error');
      if (!checked) {
        valid = false;
        if (errEl) errEl.classList.add('pa-error--visible');
      } else {
        if (errEl) errEl.classList.remove('pa-error--visible');
      }
    });

    // Validate text/email/password fields
    var requiredFields = stepEl.querySelectorAll('.pa-field[data-required="true"]');
    requiredFields.forEach(function (f) {
      var input = f.querySelector('input, textarea, select');
      if (!input) return;

      var errEl = f.querySelector('.pa-error');
      var val = input.value.trim();

      if (!val) {
        valid = false;
        input.classList.add('pa-input--error');
        if (errEl) {
          errEl.textContent = errEl.getAttribute('data-msg-required');
          errEl.classList.add('pa-error--visible');
        }
      } else if (input.type === 'email' && !isValidEmail(val)) {
        valid = false;
        input.classList.add('pa-input--error');
        if (errEl) {
          errEl.textContent = errEl.getAttribute('data-msg-email');
          errEl.classList.add('pa-error--visible');
        }
      } else if (input.type === 'password' && input.id === 'pa-password' && val.length < PASSWORD_MIN) {
        valid = false;
        input.classList.add('pa-input--error');
        if (errEl) {
          errEl.textContent = errEl.getAttribute('data-msg-password') || errEl.getAttribute('data-msg-required');
          errEl.classList.add('pa-error--visible');
        }
      } else if (input.id === 'pa-password-confirm') {
        var pwd = form.querySelector('#pa-password');
        var pwdVal = pwd ? pwd.value.trim() : '';
        if (pwdVal !== val) {
          valid = false;
          input.classList.add('pa-input--error');
          if (errEl) {
            var mismatchMsg = errEl.getAttribute('data-msg-mismatch');
            if (!mismatchMsg || mismatchMsg.indexOf('translation missing') === 0) {
              mismatchMsg = 'Passwords do not match.';
            }
            errEl.textContent = mismatchMsg;
            errEl.classList.add('pa-error--visible');
          }
        } else {
          input.classList.remove('pa-input--error');
          if (errEl) errEl.classList.remove('pa-error--visible');
        }
      } else if (input.type === 'tel' && !/^\+?[\d\s\-().]{7,20}$/.test(val)) {
        valid = false;
        input.classList.add('pa-input--error');
        if (errEl) {
          errEl.textContent = errEl.getAttribute('data-msg-phone') || errEl.getAttribute('data-msg-required');
          errEl.classList.add('pa-error--visible');
        }
      } else {
        input.classList.remove('pa-input--error');
        if (errEl) errEl.classList.remove('pa-error--visible');
      }
    });

    return valid;
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  /* ========================================================
     ASSEMBLE NOTE AND SUBMIT
     ======================================================== */
  function assembleAndSubmit() {
    var data = collectAllData();
    
    // Build human-readable note (stored in customer note field, displayed in Flow email)
    var humanReadableNote = buildHumanReadableNote(data);

    // Set hidden fields - store clean human-readable text (not JSON)
    if (noteInput) noteInput.value = humanReadableNote;

    // Parse full name → first + last
    var fullName = (data.full_name || '').trim();
    var spaceIdx = fullName.indexOf(' ');
    if (firstNameInput) {
      firstNameInput.value = spaceIdx > -1 ? fullName.substring(0, spaceIdx) : fullName;
    }
    if (lastNameInput) {
      lastNameInput.value = spaceIdx > -1 ? fullName.substring(spaceIdx + 1) : '';
    }

    // === Loading state: disable submit button ===
    if (btnSubmit) {
      btnSubmit.disabled = true;
      btnSubmit.classList.add('btn--loading');
      btnSubmit.setAttribute('aria-busy', 'true');
    }

    // === Save wizard state to sessionStorage (for recovery on server error) ===
    try {
      sessionStorage.setItem('pa-wizard-data', JSON.stringify(data));
      sessionStorage.setItem('pa-wizard-step', String(currentIndex));
      sessionStorage.setItem('pa-wizard-distributor', String(includeDistributor));
      // Flag picked up by a global checker in theme.liquid — if Shopify
      // auto-redirects the new customer to /account or home, we bounce
      // them to the professional collection instead. Short TTL (30s)
      // because the redirect lands on the next page load; a longer TTL
      // would hijack later /account visits.
      sessionStorage.setItem(PENDING_REDIRECT_KEY, JSON.stringify({
        url: REDIRECT_URL,
        exp: Date.now() + 30 * 1000
      }));
    } catch (e) { /* sessionStorage not available — proceed anyway */ }

    // === Submit form directly ===
    // Admin email notification is handled by Shopify Flow (Customer tags added -> B2B -> Send email)
    // /contact endpoint is blocked by Shopify CAPTCHA for programmatic requests
    form.submit();
  }

  /* ========================================================
     BUILD HUMAN READABLE NOTE
     Stored in customer[note] field, displayed in Shopify Flow email
     ======================================================== */
  function buildHumanReadableNote(data) {
    var lines = [];
    var now = new Date();
    var dateStr = now.toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' });
    var timeStr = now.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

    // Use pipe-separated key:value format for easy Flow parsing
    // Each value is on its own line with a unique prefix
    lines.push('PA_DATE:' + dateStr + ' ' + timeStr);
    lines.push('PA_LANG:' + pageLang.toUpperCase());
    lines.push('PA_TYPE:' + (data.pa_contact_type ? data.pa_contact_type.label : ''));
    lines.push('PA_SALON:' + (data.salon_name || ''));
    lines.push('PA_EMAIL:' + (data.email || ''));
    lines.push('PA_PHONE:' + (data.phone || ''));
    lines.push('PA_COUNTRY:' + (data.country || ''));
    lines.push('PA_CITY:' + (data.city || ''));

    if (includeDistributor) {
      lines.push('PA_DIST_COUNTRY:' + (data.distribution_country || ''));
      lines.push('PA_DIST_BRANDS:' + (data.pa_existing_distribution ? data.pa_existing_distribution.label : ''));
      lines.push('PA_DIST_SALONS:' + (data.pa_salon_count ? data.pa_salon_count.label : ''));
      lines.push('PA_DIST_TEAM:' + (data.pa_sales_team ? data.pa_sales_team.label : ''));
    }

    lines.push('PA_BIZ_TYPE:' + (data.pa_business_type ? data.pa_business_type.label : ''));
    lines.push('PA_BIZ_TREATMENTS:' + (data.pa_treatments ? data.pa_treatments.label : ''));
    lines.push('PA_BIZ_CLIENTS:' + (data.pa_clients ? data.pa_clients.label : ''));
    lines.push('PA_BIZ_TEAM:' + (data.pa_team ? data.pa_team.label : ''));
    lines.push('PA_INTEREST:' + (data.pa_interest ? data.pa_interest.label : ''));

    return lines.join('\n');
  }

  /* ========================================================
     STORE OWNER EMAIL NOTIFICATION
     Sends form data via Shopify /contact endpoint.
     This sends to the store's contact email (configured in admin).
     Returns a Promise so we can await it before form.submit().
     Uses navigator.sendBeacon() as primary (survives page unload).
     ======================================================== */

  function collectAllData() {
    var data = {};

    // Radio selections
    var radios = form.querySelectorAll('input[type="radio"]:checked');
    radios.forEach(function (r) {
      data[r.name] = {
        value: r.value,
        label: r.getAttribute('data-label') || r.value
      };
    });

    // Text inputs + selects + textareas
    var texts = form.querySelectorAll('[data-pa-field]');
    texts.forEach(function (t) {
      if (t.type !== 'radio' && t.type !== 'hidden') {
        data[t.getAttribute('data-pa-field')] = (t.value || '').trim();
      }
    });

    return data;
  }

  /* ========================================================
     BOOT
     ======================================================== */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
